module.exports = __webpack_public_path__ + "static/img/flow3.163cf422.svg";